<template>
  <!-- 发货 -->
  <div class="wrapper delivery-page">
    <admin-title title="OK·发货控制台"></admin-title>

    <div class="delivery-summary">
      <div class="summary-field">
        <span>客户姓名</span
        ><strong>{{
          orderSummary.member ? orderSummary.member.memberName : "-"
        }}</strong>
      </div>
      <div class="summary-field">
        <span>订单号</span><strong>{{ $route.params.id }}</strong>
      </div>
      <div class="summary-field summary-goods">
        <span>商品</span
        ><strong
          >{{
            orderSummary.orderGoods ? orderSummary.orderGoods.skuTitle : "-"
          }}
          <el-tag
            v-if="
              orderSummary.orderGoods && orderSummary.orderGoods.goodsPurityName
            "
            size="mini"
            :type="
              orderSummary.orderGoods.goodsPurity === 'fresh'
                ? 'primary'
                : 'warning'
            "
            >{{ orderSummary.orderGoods.goodsPurityName }}</el-tag
          ></strong
        >
      </div>
      <div class="summary-alerts">
        <el-tag v-if="whitelistTip" type="success" effect="dark"
          ><i class="el-icon-check" /> {{ whitelistTip }}</el-tag
        >
        <el-tag v-if="blacklistTip" type="danger" effect="dark"
          ><i class="el-icon-remove-outline" /> {{ blacklistTip }}</el-tag
        >
        <el-tag v-if="fullPayTip" type="warning" effect="dark"
          ><i class="el-icon-warning-outline" /> {{ fullPayTip }}</el-tag
        >
      </div>
    </div>

    <div v-if="showDeliveryTabs" class="header">
      <el-tabs v-model="activeName">
        <el-tab-pane
          v-if="
            deliveryType.indexOf(1) > -1 && enableMaterialDelivery && type == 1
          "
          label="物流配送"
          name="1"
        ></el-tab-pane>
        <el-tab-pane
          v-if="
            deliveryType.indexOf(2) > -1 && enableMaterialDelivery && type == 1
          "
          label="门店自提"
          name="2"
        ></el-tab-pane>
        <el-tab-pane
          v-if="
            deliveryType.indexOf(3) > -1 && enableVirtualDelivery && type == 2
          "
          label="虚拟发货"
          name="3"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 普通订单 -->
    <DeliveryPt
      v-if="activeName == 1"
      :block-tip-status="blockTipStatus"
    ></DeliveryPt>

    <!-- 门店订单 -->
    <DeliveryStore
      v-if="activeName == 2"
      :block-tip-status="blockTipStatus"
    ></DeliveryStore>
    <DeliveryVirtual
      v-if="activeName == 3"
      :block-tip-status="blockTipStatus"
    />
  </div>
</template>

<script>
import DeliveryPt from "./delivery-putong.vue";
import DeliveryStore from "./delivery-store.vue";
import DeliveryVirtual from "./delivery-virtual.vue";
import {
  refreshRiskMemberAPI,
  getDetailAPI,
} from "@/views/order/order-list/api";

export default {
  name: "Delivery",
  components: { DeliveryPt, DeliveryStore, DeliveryVirtual },
  data() {
    return {
      activeName: "1",
      deliveryType: [],
      enableMaterialDelivery: false,
      enableVirtualDelivery: false,
      type: "",
      whitelistTip: "",
      blacklistTip: "",
      fullPayTip: "",
      blockTipStatus: false,
      orderSummary: {},
    };
  },
  computed: {
    showDeliveryTabs() {
      return (
        this.type == 1 &&
        this.enableMaterialDelivery &&
        this.deliveryType.includes(1) &&
        this.deliveryType.includes(2)
      );
    },
  },
  watch: {
    deliveryType: {
      immediate: true,
      handler(newV, oldV) {
        if (
          this.deliveryType.indexOf(3) > -1 &&
          this.enableVirtualDelivery &&
          this.type == 2
        ) {
          this.activeName = "3";
        }
        if (
          this.deliveryType.indexOf(2) > -1 &&
          this.enableMaterialDelivery &&
          this.type == 1
        ) {
          this.activeName = "2";
        }
        if (
          this.deliveryType.indexOf(1) > -1 &&
          this.enableMaterialDelivery &&
          this.type == 1
        ) {
          this.activeName = "1";
        }
      },
    },
  },
  mounted() {
    this.deliveryType = JSON.parse(localStorage.getItem("deliveryTypeList"));
    this.enableMaterialDelivery = JSON.parse(
      localStorage.getItem("enableMaterialDelivery"),
    );
    this.enableVirtualDelivery = JSON.parse(
      localStorage.getItem("enableVirtualDelivery"),
    );
    this.type = JSON.parse(localStorage.getItem("btn_type"));
    getDetailAPI(this.$route.params.id).then((detail) => {
      this.orderSummary = detail;
    });
    this.refreshOrderRiskMember();
  },

  methods: {
    async refreshOrderRiskMember() {
      const res = await refreshRiskMemberAPI(this.$route.params.id);
      if (res.isWhitelist) {
        this.whitelistTip = "白名单";
      }
      if (res.isBlacklist) {
        this.blacklistTip = "黑名单";
        if (!res.isWhitelist) {
          this.blockTipStatus = true;
        }
      }
      if (!res.isFullPay) {
        this.fullPayTip = "客户有未结清订单，请复核后谨慎操作！";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 48px;
  padding: 20px 24px;
  margin-bottom: 16px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
}
.summary-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  > span {
    color: #909399;
    font-size: 14px;
  }
  strong {
    font-size: 18px;
    color: #303133;
    overflow-wrap: anywhere;
  }
}
.summary-goods {
  flex: 1;
  min-width: 200px;
}
.summary-alerts {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .el-tag {
    height: auto;
    padding: 8px 14px;
    font-size: 16px;
    line-height: 22px;
    white-space: normal;
  }
}
.wrapper {
  width: 100%;
}
.delivery-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
</style>
